var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert text-center text-capitalize",class:_vm.alertColorClass,attrs:{"role":"alert"}},[_vm._t("icon",function(){return [_c('i',{staticClass:"px-1",class:_vm.icon}),_vm._v(_vm._s(_vm.text)+" ")]},{"icon":_vm.icon,"text":_vm.text})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }